module.exports = __webpack_public_path__ + "static/banner-45dcc94a2bc68cd1ffc4372f938fd349.png";